import { useNavigation } from "@react-navigation/core";
import { Button, Center, Text, VStack } from "native-base";

type Props = {};

export function SelectionPage({}: Props) {
  const navigation = useNavigation();

  const handleNavigateToBeforeTreatment = () => {
    navigation.navigate("BeforeTreatment");
  };

  const handleNavigateToDuringTreatment = () => {
    navigation.navigate("DuringTreatment");
  };

  const handleNavigateToAfterTreatment = () => {
    navigation.navigate("AfterTreatment");
  };

  return (
    <Center p={10} flex={1} bgColor="white">
      <VStack w="100%" alignItems="center" space={12}>
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          color="#f4545c"
        >
          Selecione a opção que melhor descreve a sua situação atual
        </Text>

        <VStack space={8} w="80%">
          <Button
            bg="#c8bfb6"
            _text={{ fontWeight: "bold", color: "white", fontSize: "lg" }}
            onPress={handleNavigateToBeforeTreatment}
          >
            Antes do tratamento
          </Button>
          <Button
            bg="#abb79c"
            _text={{ fontWeight: "bold", color: "white", fontSize: "lg" }}
            onPress={handleNavigateToDuringTreatment}
          >
            Durante o tratamento
          </Button>
          <Button
            bg="#b19286"
            _text={{ fontWeight: "bold", color: "white", fontSize: "lg" }}
            onPress={handleNavigateToAfterTreatment}
          >
            Depois do tratamento
          </Button>
        </VStack>
      </VStack>
    </Center>
  );
}
